import React, { Component } from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import _ from "lodash";
import util from "../util/util";
import Pagination from "../pagination/pagination";
import RuleListSearchForm from "./rule-list-search-form";
import RuleListTable from "./rule-list-table";

// use the same logic to set state (on load, on prop change);
const returnInitialState = (props = {}) => ({
  page: Number(_.get(props, `params.page`, 1)), // page of rule results;
  rules: [], // rules to display (will be populated by an Ajax call);
  queryString: _.get(props, `location.search`, null), // pass to sort and pagination links to maintain search state;
  search: _.get(props, `location.query.search`, null), // search string;
  status: _.get(props, `location.query.status`, `live`), // search status;
  sort: _.get(props, `location.query.sort`, `-start_date`), // list sort value;
  timeslot: _.get(props, `location.query.timeslot`, null) // search timeslot;
});

export default class RuleList extends Component {
  constructor(props) {
    super(props);

    this.state = returnInitialState(props);
  }

  componentDidMount() {
    this.mounted = true;

    this.getRules();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    this.setState(returnInitialState(nextProps), this.getRules);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-xs-6">
            <h4 className="page__title">Rules</h4>
          </div>
          <div className="col-xs-6">
            <p className="page__actions">
              <Link to="/rule/form/0/" className="btn btn-primary">
                <i className="fa fa-plus" aria-hidden="true"></i>
                Create New Rule
              </Link>
            </p>
          </div>
        </div>

        <RuleListSearchForm
          search={this.state.search}
          sort={this.state.sort}
          status={this.state.status}
          timeslot={this.state.timeslot}
        />

        <RuleListTable
          currentPage={this.state.page}
          rules={this.state.rules}
          queryString={this.state.queryString}
          sort={this.state.sort}
        />

        <Pagination
          currentPage={this.state.page}
          pageCount={this.state.pageCount}
          path="rules"
          queryString={this.state.queryString}
        />
      </div>
    );
  }

  // get the rule data to display (one page at a time);
  getRules() {
    util
      .getRules({
        page: this.state.page,
        search: this.state.search,
        sort: this.state.sort,
        status: this.state.status,
        timeslot: this.state.timeslot
      })
      .then(data => {
        setTimeout(() => {
          this.mounted &&
            this.setState({
              pageCount: Math.ceil(data.count / util.ruleResultsPerPage),
              rules: data.results.length ? data.results : false
            });
        }, util.delayList);
      });
  }
}

RuleList.propTypes = {
  location: PropTypes.object,
  params: PropTypes.object
};
